import { usePrescription } from "src/context/PrescriptionProvider";
import PrescriptionRequest2 from "./PrescriptionRequest2";
import PrescriptionRequest from "./PrescriptionRequest";

interface Props {
  onSuccess: () => Promise<void>;
  patientRegion: string | null;
}

const PrescriptionRequestFinal = (props: Props) => {
  const form = usePrescription((p) => p.metadata?.["form"]);
  const quantity = usePrescription((p) => p.dispense_quantity);
  const slug = usePrescription((p) => p.product.slug);

  if (["aa-ot", "ac-ot", "ro-ot"].includes(slug)) {
    return <PrescriptionRequest {...props} />;
  }

  if (
    (form == null && quantity == null) ||
    form === "oral" ||
    slug === "ed-ot"
  ) {
    return <PrescriptionRequest2 {...props} />;
  } else {
    return <PrescriptionRequest {...props} />;
  }
};

export default PrescriptionRequestFinal;
